<template>
  <vx-card class="mt-base mb-5">
    <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
    <p class="mb-5">
      This exercise is a little bit of fun, but we can learn some useful information from it too.
    </p>
    <p class="mb-5">
      1. First, watch the video linked below - it doesn’t matter if you’ve seen it before, just take
      a look again!
    </p>
    <p class="mb-5">
      It’s best to watch this short video wearing headphones for the optimum effect (and it’s only
      small so you’ll probably need to get up close)
    </p>

    <custom-video
      aria-label="Watch observation skills video"
      elem-id="video-btn-0"
      :video-image="videoTrigger1"
      :video-url="videos[1]"
    />

    <div class="focusable-parent">
      <label>
        2. Now immediately record the physical sensations you felt right after watching the video.

        <textarea-block
          class="focus-visible-style"
          v-model="data.question1"
          :editable="isEditable"
        />
      </label>
    </div>

    <p class="mb-5">
      Did your heart rate rise? Did your breathing change? If you’ve seen the video before, how did
      you feel watching it? Anxious?
    </p>
    <p class="mb-5">
      The effect of watching a scary movie or being surprised can, in some ways, be similar to the
      effects of stress. However, while we might enjoy the temporary shock and excitement of a movie
      scare, the long term effects of stress can be truly terrifying! We need to find ways to help
      us to relax and manage the effects of stress in our lives.
    </p>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import CustomVideo from '@/components/CustomVideo';

export default {
  components: {
    CustomVideo,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/psychology/jump_scare_splash.jpg'),
      videos: {
        1: $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/content/psychology/jump_scare.mp4',
      },
      login_type: localStorage.getItem('login_type'),
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
